/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { IDs } from '../models/IDs';

export class User {
  /**
  * The ID of the user
  */
  'id': string;
  /**
  * The given name of the user
  */
  'givenName': string;
  /**
  * The email of the user
  */
  'email'?: string;
  /**
  * The date the user expires
  */
  'expiresAt'?: string;
  /**
  * The role to projects mappings of the viewer
  */
  'roleToProjectsMappings': { [key: string]: IDs; };
  /**
  * The origin of the user - Local for users who were added manually, and the specific Idp name for users who were added via SSO
  */
  'userOrigin'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "givenName",
      "baseName": "givenName",
      "type": "string",
      "format": ""
    },
    {
      "name": "email",
      "baseName": "email",
      "type": "string",
      "format": ""
    },
    {
      "name": "expiresAt",
      "baseName": "expiresAt",
      "type": "string",
      "format": ""
    },
    {
      "name": "roleToProjectsMappings",
      "baseName": "roleToProjectsMappings",
      "type": "{ [key: string]: IDs; }",
      "format": ""
    },
    {
      "name": "userOrigin",
      "baseName": "userOrigin",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return User.attributeTypeMap;
  }

  public constructor() {
  }
}

